import React, {Component} from 'react';
import { Link } from 'gatsby';
import createTaxonomyLink from '../utils/createTaxonomyLink';
import {connectToStore} from './Provider';
import ProductCardCarousel from './ProductCardCarousel';
import Flickity from './Flickity';

const DESKTOP_SLIDE_OPTIONS = {
	cellAlign: 'left',
	contain: true,
	pageDots: false,
	wrapAround: true,
	prevNextButtons: false,
	freeScroll: true,
	freeScrollFriction: 0.05,
};

const MOBILE_SLIDE_OPTIONS = {
	cellAlign: 'left',
	contain: true,
	pageDots: false,
	wrapAround: true,
	prevNextButtons: false,
	selectedAttraction: 0.1,
	friction: 0.8
};

class RelatedProductsPromo extends Component {
	constructor() {
		super();

		this.sliders = [];
	}

	onSetSliderRef = sliderRef => {
		this.sliders.push(sliderRef);
	}

	onClickPrevious = () => {
		this.sliders.forEach(slider => slider.previous());
	}

	onClickNext = () => {
		this.sliders.forEach(slider => slider.next());
	}

	render() {
		const {
			title,
			subtitle,
			shopAllLink,
			products,
			openVideoModal,
		} = this.props;

		let shopAllLinkButton;

		if (shopAllLink._type === 'link') {
			if (shopAllLink.url[0] === '/') {
				shopAllLinkButton = (
					<Link
						className="full-width button--secondary"
						title={shopAllLink.title}
						to={shopAllLink.url}>
						{shopAllLink.title}
					</Link>
				);
			} else {
				shopAllLinkButton = (
					<a
						className="full-width button--secondary"
						title={shopAllLink.title}
						href={shopAllLink.url}>
						{shopAllLink.title}
					</a>
				);
			}
		} else if (shopAllLink._type === 'videoModalLink') {
			shopAllLinkButton = (
				<button
					title={shopAllLink.title}
					className="full-width button--secondary"
					onClick={() => openVideoModal(shopAllLink.videoId)}
					name="video">
					{shopAllLink.title}
				</button>
			);
		} else if (shopAllLink._type === 'taxonomyLink') {
			shopAllLinkButton = (
				<Link
					className="full-width button--secondary"
					title={shopAllLink.title}
					to={createTaxonomyLink(shopAllLink.taxonomies)}>
					{shopAllLink.title}
				</Link>
			);
		}
		
		return (
			<div className="mt6 mb6 mt12--md mb12--md of--hidden">
				<div className="grid-container contained mb6">
					<div className="media media--reverse media--horizontal gutter--none align--bottom">
						<div className="media__fluid">
							<div className="tc tl--md">
								{subtitle && (
									<h3 className="uppercase fw--600 mb1 mb2--md">{subtitle}</h3>
								)}
								<h2 className="domaine--large">{title}</h2>
							</div>
						</div>
						<div className="media__fixed show--md">
							{shopAllLinkButton}
						</div>
					</div>
				</div>
				<div className="show--md">
					<div className="grid-container contained mb8 product-carousel">
						<Flickity
							sliderRef={this.onSetSliderRef}
							options={DESKTOP_SLIDE_OPTIONS}>
							{products.map((product, index) => (
								<div
									className="product-carousel__product-col"
									key={`${index}_${product._key}`}>
									<ProductCardCarousel
										title={product.title}
										slug={product.slug}
										mainImage={product.mainImage}
										cents={product.cents}
										brand={product.brand}
									/>
								</div>
							))}
						</Flickity>
					</div>
				</div>

				<div className="hide--md">
					<div className="grid-container contained product-carousel mb4 pr">
						<Flickity
							sliderRef={this.onSetSliderRef}
							options={MOBILE_SLIDE_OPTIONS}>
							{products.map((product, index) => (
								<div
									className="product-carousel__product-col"
									key={`${index}_${product._key}`}>
									<ProductCardCarousel
										title={product.title}
										slug={product.slug}
										mainImage={product.mainImage}
										cents={product.cents}
										brand={product.brand}
									/>
								</div>
							))}
						</Flickity>
						<button
							title="Previous"
							name="previous"
							onClick={this.onClickPrevious}>
							<img
								className="db flip m--auto"
								alt="next"
								src="/images/icon-carousel-next.svg"
							/>
						</button>
						<button
							title="Next"
							name="next"
							onClick={this.onClickNext}>
							<img
								className="db m--auto"
								alt="next"
								src="/images/icon-carousel-next.svg"
							/>
						</button>
					</div>
				</div>

				<div className="grid-container contained hide--md mt4">
					{shopAllLinkButton}
				</div>
			</div>
		);
	}
}

RelatedProductsPromo.defaultProps = {
	products: []
};

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(RelatedProductsPromo);